/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboPouchManagementBadRequestResponse,
  BboPouchManagementFailureResponseResponse,
  BboPouchManagementForbiddenResponse,
  GetPouchIDListResponseResponse,
  NoContentResponse,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * This Api is used get the list of Pouch ID's based on the commodity and pouch status
 * @summary Get Pouch list based on the status and commodity
 */
export const getPouchesBasedOnStatus = (
  pouchType: 'cash' | 'forex' | 'stock',
  status: 'suspended',
  signal?: AbortSignal,
) => {
  return customInstance<GetPouchIDListResponseResponse | NoContentResponse>({
    url: `/bm-pouch-management/v1/pouch-activity/${pouchType}/${status}`,
    method: 'get',
    signal,
  });
};

export const getGetPouchesBasedOnStatusQueryKey = (
  pouchType: 'cash' | 'forex' | 'stock',
  status: 'suspended',
) => {
  return [`/bm-pouch-management/v1/pouch-activity/${pouchType}/${status}`] as const;
};

export const getGetPouchesBasedOnStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getPouchesBasedOnStatus>>,
  TError = ErrorType<
    | BboPouchManagementBadRequestResponse
    | UnauthorizedResponse
    | BboPouchManagementForbiddenResponse
    | BboPouchManagementFailureResponseResponse
  >,
>(
  pouchType: 'cash' | 'forex' | 'stock',
  status: 'suspended',
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPouchesBasedOnStatus>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPouchesBasedOnStatusQueryKey(pouchType, status);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPouchesBasedOnStatus>>> = ({
    signal,
  }) => getPouchesBasedOnStatus(pouchType, status, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(pouchType && status),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getPouchesBasedOnStatus>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetPouchesBasedOnStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPouchesBasedOnStatus>>
>;
export type GetPouchesBasedOnStatusQueryError = ErrorType<
  | BboPouchManagementBadRequestResponse
  | UnauthorizedResponse
  | BboPouchManagementForbiddenResponse
  | BboPouchManagementFailureResponseResponse
>;

/**
 * @summary Get Pouch list based on the status and commodity
 */
export const useGetPouchesBasedOnStatus = <
  TData = Awaited<ReturnType<typeof getPouchesBasedOnStatus>>,
  TError = ErrorType<
    | BboPouchManagementBadRequestResponse
    | UnauthorizedResponse
    | BboPouchManagementForbiddenResponse
    | BboPouchManagementFailureResponseResponse
  >,
>(
  pouchType: 'cash' | 'forex' | 'stock',
  status: 'suspended',
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPouchesBasedOnStatus>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetPouchesBasedOnStatusQueryOptions(pouchType, status, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
